var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBooks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M173.51,160.68s-33.7-14.3-64,5.12m-64.35-5.12s33.7-14.3,64,5.12M173.51,60.87v86.19s-33.7-14.31-64,5.11V65.3S138.78,43.15,173.51,60.87Zm-128.35,0v86.19s33.7-14.31,64,5.11V65.3S79.88,43.15,45.16,60.87Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooks);
export default __webpack_public_path__ + "static/media/BOOKS.79161d5493453899c49b4a4a5fa6f20b.svg";
export { ForwardRef as ReactComponent };